/** @jsx jsx */
import { h, FunctionalComponent, Fragment } from 'preact'
import { useState, useEffect, useRef } from 'preact/hooks'
import { jsx } from '@emotion/core'
import { fetchPosts } from './groupOfLinksService'
import { Post } from './types'
import { useSiteVars } from '../../themes/useSiteVars'
import { getDefaultGroupOfLinksStylesObj } from './groupOfLinks.styles'
import { useAnalytics } from './analytics/useAnalytics'
import { Link } from './components/Link'
import { Divider } from './components/Divider'
import { LinkWithImage } from './components/LinkWithImage'

const SWIMSUIT_SLUG = 'si_swimsuit'
interface GroupOfLinksProps {
    url: string
    embedName?: string
    withImages?: string
}

const GroupOfLinks: FunctionalComponent<GroupOfLinksProps> = ({ url, embedName = '', withImages = 'false' }) => {
    const siteVars = useSiteVars()
    const [posts, setPosts] = useState<Post[]>([])
    const [isSwimsuit, setIsSwimsuit] = useState(false)
    const shouldRenderWithImages = withImages === 'true'
    const groupOfLinksStyles = getDefaultGroupOfLinksStylesObj(siteVars, isSwimsuit, shouldRenderWithImages)
    const [currentArticleId, setCurrentArticleId] = useState('')
    const ref = useRef<HTMLDivElement>(null)
    const { onLinkClick } = useAnalytics(posts.length, ref.current, embedName, shouldRenderWithImages)

    useEffect(() => {
        const getPosts = async () => {
            const { posts: postsData, property } = await fetchPosts(url)
            setPosts(postsData)
            setIsSwimsuit(property === SWIMSUIT_SLUG)
        }
        getPosts()
    }, [url])

    useEffect(() => {
        window.mmClientApi = window.mmClientApi || []
        window.mmClientApi.push('getPageData', (postData: any) => {
            setCurrentArticleId(postData.articleId)
        })
    }, [])

    useEffect(() => {
        const articleIdFromEmbedElement = document.getElementById('embed')?.getAttribute('articleId')
        articleIdFromEmbedElement && setCurrentArticleId(articleIdFromEmbedElement)
    }, [])

    useEffect(() => {
        window.parent.postMessage(
            {
                sentinel: 'amp',
                type: 'embed-size',
                height: ref.current.clientHeight,
            },
            '*',
        )
    }, [posts])

    return (
        <div ref={ref} css={groupOfLinksStyles.wrapper}>
            {shouldRenderWithImages && !isSwimsuit && <Divider styles={groupOfLinksStyles} />}
            {posts.map((post, index) => {
                return post.verified && currentArticleId !== post.id ? (
                    shouldRenderWithImages ? (
                        <LinkWithImage
                            isSwimsuit={isSwimsuit}
                            index={index}
                            post={post}
                            onLinkClick={onLinkClick}
                            styles={groupOfLinksStyles}
                        />
                    ) : (
                        <Link index={index} post={post} onLinkClick={onLinkClick} styles={groupOfLinksStyles} />
                    )
                ) : (
                    <Fragment></Fragment>
                )
            })}
        </div>
    )
}

export default GroupOfLinks
